import assetPath from '/app/brewery-packages/xds/super-ellipse/src/assets/super-ellipse-mask.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')